import React from "react";
import "./AboutUs.css";
import { Col, Container, Row } from "react-bootstrap";
import WhyChoose from "../HomePages/WhyChoose";
import AboutOne from "./AboutOne";
import { Link } from "react-router-dom";
// import WhyChoose from "../Home/innerComponents/WhyChoose";
// import WhyChoose from "../Home/innerComponents/WhyChoose";
const AboutUs = () => {
  return (
    <div>
      <section className="page-header">
        <div
          className="page-header-bg"
          style={{
            backgroundImage:
              "url('https://img.freepik.com/premium-photo/airplane-wing-clouds-sunset_412311-9717.jpg?w=900')",
          }}
        ></div>
        <div className="container">
          <div className="page-header__inner">
            <h2>About us</h2>
            <ul className="thm-breadcrumb list-unstyled">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <span>/</span>
              </li>
              <li>About Us</li>
            </ul>
          </div>
        </div>
      </section>
      {/* <section class="bannerInner">
        <div class="container">
          <h1>
            <b>About Us</b>
          </h1>
        </div>
      </section> */}
      <section
        className="section_padding"
        style={{ paddingTop: "75px", paddingBottom: "0px" }}
      >
        <Container>
          <div className="text-center">
            <h2>
              <b>About Yatri Service</b>
            </h2>
            <p>
              Welcome to Yatri Service, your premier B2B travel portal dedicated
              to transforming the way businesses navigate the world of travel.
              At Yatri Service, we understand the unique needs of the travel
              industry and are committed to providing tailored solutions that
              empower businesses to thrive.
            </p>
          </div>
        </Container>
      </section>

      <section className="about-four">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6" style={{ marginBlock: "auto" }}>
              <div
                className="about-four__left wow slideInLeft animated"
                data-wow-delay="100ms"
                data-wow-duration="2500ms"
                style={{
                  visibility: "visible",
                  animationDuration: "2500ms",
                  animationDelay: "100ms",
                  animationName: "slideInLeft",
                }}
              >
                <div className="about-four__img">
                  <img
                    src="https://img.freepik.com/premium-photo/editorial-man-control-airviation_7180-40.jpg?w=900"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6" style={{ marginBlock: "auto" }}>
              <div className="about-four__right">
                <div className="section-titlefsdf text-left">
                  <span className="section-title__taglinedfsd">
                    Our Mission
                  </span>
                  <h2 className="section-title__titledsfs">
                    The best B2B Travel Portal
                  </h2>
                </div>
                <p className="about-four__text-1">
                  At Yatri Service, our mission is to simplify and elevate the
                  travel experience for our B2B partners. We strive to be the
                  preferred travel portal by delivering cutting-edge technology,
                  unparalleled service, and strategic partnerships that drive
                  business success.
                </p>
                <p className="about-four__text-2">
                  Empowering Business Success: We are dedicated to empowering
                  the success of our B2B partners by providing them with a
                  dynamic platform that seamlessly integrates cutting-edge
                  technology, strategic partnerships, and industry insights. Our
                  mission is to be the driving force behind the growth and
                  profitability of businesses in the travel sector.
                </p>
                <a className="thm-btn about-four__btn">Dicover more</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-four">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6" style={{ marginBlock: "auto" }}>
              <div className="about--founr_left">
                <div className="section-titlefsdf text-left">
                  <span className="section-title__taglinedfsd">
                    What Sets Us Apart
                  </span>
                  <h2 className="section-title__titledsfs">
                    The best B2B Travel Portal
                  </h2>
                </div>
                <p className="about-four__text-1">
                  Yatri Service is exclusively designed for businesses in the
                  travel industry. Whether you are a travel agency, tour
                  operator, or corporate entity, our platform is crafted to meet
                  your specific requirements, offering a comprehensive suite of
                  tools and services.
                </p>
                <p
                  className="about-four__text-2"
                  style={{ paddingBottom: "0px" }}
                >
                  We leverage the latest technology to bring efficiency,
                  transparency, and innovation to your fingertips. Our
                  user-friendly portal is equipped with advanced features to
                  streamline booking processes, manage reservations, and access
                  real-time data, ensuring you stay ahead in a dynamic market.
                </p>
                <p className="about-four__text-2">
                  Your success is our priority. Yatri Service is more than a
                  platform; it's a partnership. Our dedicated support team is
                  committed to providing personalized assistance, ensuring that
                  your business experiences seamless operations and growth.
                </p>
                <a className="thm-btn about-four__btn">Dicover more</a>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6" style={{ marginBlock: "auto" }}>
              <div
                className="about-four__left wow slideInLeft animated"
                data-wow-delay="100ms"
                data-wow-duration="2500ms"
                style={{
                  visibility: "visible",
                  animationDuration: "2500ms",
                  animationDelay: "100ms",
                  animationName: "slideInLeft",
                }}
              >
                <div className="about-four__img about-four__img_left">
                  <img
                    src="https://img.freepik.com/free-photo/couple-interacting-with-each-other-check-counter_107420-85045.jpg?t=st=1736426055~exp=1736429655~hmac=4d747669ea9116e5570ef2f2a8281d3d90a4b67a6bef10d0bacc5c77ced75684&w=900"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="bannerInner">
        <div className="container">
          <h1>
            <b>About Us</b>
          </h1>
        </div>
      </section>
      <section className="section_padding">
        <Container>
          <div className="text-center">
            <h2>
              <b>About Yatri Service</b>
            </h2>
            <p>
              Welcome to Yatri Service, your premier B2B travel portal dedicated
              to transforming the way businesses navigate the world of travel.
              At Yatri Service, we understand the unique needs of the travel
              industry and are committed to providing tailored solutions that
              empower businesses to thrive.
            </p>
          </div>
        </Container>
      </section>
      <section className="section_padding">
        <Container>
          <Row>
            <Col md={6}>
              <div>
                <h2>
                  <b>Our Mission</b>
                </h2>
                <p>
                  At Yatri Service, our mission is to simplify and elevate the
                  travel experience for our B2B partners. We strive to be the
                  preferred travel portal by delivering cutting-edge technology,
                  unparalleled service, and strategic partnerships that drive
                  business success.
                </p>
                <p>
                  Empowering Business Success: We are dedicated to empowering
                  the success of our B2B partners by providing them with a
                  dynamic platform that seamlessly integrates cutting-edge
                  technology, strategic partnerships, and industry insights. Our
                  mission is to be the driving force behind the growth and
                  profitability of businesses in the travel sector.
                </p>
              </div>
            </Col>
            <Col md={6}>
              <img
                src="https://admin.yatriservice.com/public/images/our-mission.jpg"
                className="img-fluid"
                alt="Expand Sales"
              />
            </Col>
          </Row>
        </Container>
      </section>
     
      <section className="section_padding">
        <Container>
          <Row>
            <Col md={6}>
              <img
                src="https://admin.yatriservice.com/public/images/what-set-apart.jpg"
                className="img-fluid"
                alt="Expand Sales"
              />
            </Col>
            <Col md={6}>
              <div>
                <h2>
                  <b>What Sets Us Apart</b>
                </h2>
                <p>
                  Yatri Service is exclusively designed for businesses in the
                  travel industry. Whether you are a travel agency, tour
                  operator, or corporate entity, our platform is crafted to meet
                  your specific requirements, offering a comprehensive suite of
                  tools and services.
                </p>
                <p>
                  We leverage the latest technology to bring efficiency,
                  transparency, and innovation to your fingertips. Our
                  user-friendly portal is equipped with advanced features to
                  streamline booking processes, manage reservations, and access
                  real-time data, ensuring you stay ahead in a dynamic market.
                </p>
                <p>
                  Your success is our priority. Yatri Service is more than a
                  platform; it's a partnership. Our dedicated support team is
                  committed to providing personalized assistance, ensuring that
                  your business experiences seamless operations and growth.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
      <WhyChoose />
    </div>
  );
};

export default AboutUs;
